export const SIZES = { NORMAL: 'normal', SMALL: 'small', LARGE: 'large' };
